import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { defineMessages, useIntl } from "react-intl";

import { useApi } from "@/hooks";
import toast from "@/toast";

import type { ApiError } from "@/types/api";

const messages = defineMessages({
  success: {
    id: "change_password.success",
    defaultMessage: "Password successfully updated.",
  },
  error: {
    id: "change_password.error",
    defaultMessage: "Change password failed.",
  },
});

interface Params {
  password: string;
  resetPasswordToken: string;
}

function useConfirmPasswordReset() {
  const api = useApi();
  const intl = useIntl();

  return useMutation({
    mutationFn: (params: Params) =>
      api.post<Response>("/api/v1/truth/password_reset/confirm", {
        password: params.password,
        reset_password_token: params.resetPasswordToken,
      }),
    onSuccess: () => {
      toast.success(intl.formatMessage(messages.success));
    },
    onError(error: AxiosError<ApiError>) {
      toast.error(
        error.response?.data?.error_message ||
          intl.formatMessage(messages.error),
      );
    },
  });
}

export { useConfirmPasswordReset };
